<template>
  <div class="AppRoleList">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList('search')">
      <el-form-item label="权限名称">
        <el-input v-model="searchForm.appRoleName" placeholder="权限名称"></el-input>
      </el-form-item>

      <!-- <el-form-item label="所有者">
        <el-input v-model="searchForm.owner"
                  placeholder="所有者"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" plain type="primary" @click="reset()">清空
        </el-button>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus" size="small" type="primary" @click="openModifyDialog()">添加管理者权限
          </el-button>
        </el-col>
      </el-row>

    </el-form>
    <el-table class="dataTable" v-loading="dataListLoading" :data="dataList"
              :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border>
      <el-table-column label="权限名称" prop="appRoleName">
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openDetailDialog(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="openModifyDialog(scope.row)" v-if="scope.row.shared!=255">编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.shared!=255">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--    <el-pagination :current-page="pageIndex" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="totalPage"
                       background layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>-->

    <!-- 新增&修改管理者权限信息 -->
    <el-dialog :title="modifyForm.appRoleId ? '修改管理者权限' : '添加管理者权限'" :visible.sync="modifyDialog" width="50%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm" ref="modifyForm" :model="modifyForm" :rules="modifyRule" label-width="40%">

        <el-form-item label="管理者权限名称" prop="appRoleName">
          <el-input style="width: 200px;" v-model="modifyForm.appRoleName " placeholder="请输入管理者权限名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>


        <el-form-item label="菜单" prop="appMenuIdList">
          <el-checkbox-group v-model="appMenuIdList">
            <el-checkbox v-for="item in allAppMenuList"
                         :key="item.appMenuId"
                         :label="item.appMenuId"
            >{{ item.appMenuName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary" @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 角色下菜单详情 -->
    <el-dialog :title="`菜单详情--`+`${detailForm.appRoleName}`+`，包含(`+`${detailForm.menuList.length}`+`)个:`"
               :visible.sync="detailDialog" width="40%"
               :before-close="cancelDetailDialog">

      <el-form class="modifyForm" ref="modifyForm" label-width="40%" v-loading="dataListLoading">
        <el-checkbox v-for="item in detailForm.menuList"
                     :key="item.appMenuId"
                     :label="item.appMenuId"
                     :checked="item.checked"
                     disabled
        >{{ item.appMenuName }}
        </el-checkbox>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/AppRoleList.css'

export default {
  data() {
    return {
      userInfo: {},
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 1,
      modifyDialog: false,
      modifyForm: {appRoleName: ''},
      modifyRule: {
        appRoleName: [{
          required: true,
          message: '管理者权限名称不能为空',
          trigger: 'blur'
        },],
      },
      detailDialog: false,
      detailForm: {
        appRoleName: '',
        menuList: [],
      },
      allAppMenuList: [],
      appMenuIdList: [],
    }
  },

  computed: {},

  created() {
    let self = this

    if (sessionStorage.getItem('userInfo')) {
      self.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }

    self.getDataList()
  },

  mounted() {
  },

  methods: {
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      let param = {}

      if (type == 'search') {
        self.pageIndex = 1
        if (self.searchForm.appRoleName != '')
          param.appRoleName = self.searchForm.appRoleName
      }

      self.dataListLoading = true


      self.$axios
        ._getAppRoleList(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            let _dataList = datas.data
            if (_dataList) {
              self.dataList = _dataList
            } else {
              self.$message.error('还没有创建管理者权限')
              self.dataList = []
            }

            self.totalPage = self.dataList.length
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false

    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 1
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (item) {
      let self = this

      // ------修改 开始-----------
      if (item && item.appRoleId > 0) {

        self.$axios
          ._getAppRoleDetail({appRoleId: item.appRoleId})
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.modifyForm.appRoleId = datas.data.appRoleId
              self.modifyForm.appRoleName = datas.data.appRoleName

              self.allAppMenuList = datas.data.menuList
              self.appMenuIdList = self.allAppMenuList.filter((data) => {
                return data.checked
              })

              self.appMenuIdList = []
              for (let i = 0; i < self.allAppMenuList.length; i++) {
                const obj = self.allAppMenuList[i];
                if (obj.checked) {
                  self.appMenuIdList.push(obj.appMenuId)
                }
              }

              self.modifyDialog = true
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理者')
          })

        return
      }
      // ------修改 结束-----------

      // ------添加 开始-----------
      if (self.allAppMenuList.length === 0) {
        self.$axios
          ._getAppMenuList({})
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.allAppMenuList = datas.data


              self.modifyDialog = true
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理者')
          })
      } else {

        self.modifyDialog = true
      }

      // ------添加 结束-----------

    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      let appRoleName = self.modifyForm.appRoleName
      console.log("==================:", appRoleName, self.appMenuIdList)

      if (appRoleName == '' || self.appMenuIdList.length == 0) {
        self.$message.error('参数不合格')
        return
      }


      let param = {
        appRoleName: appRoleName,
        appMenuIdList: self.appMenuIdList,
      }

      if (self.modifyForm.appRoleId) {

        param.appRoleId = self.modifyForm.appRoleId

        self.$axios
          ._editAppRole(param)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('修改成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理者权限描述')
          })

      } else {

        self.$axios
          ._addAppRole(param)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理者权限描述')
          })
      }
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      // Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      // self.$refs.modifyForm.resetFields()
      self.modifyForm = {appRoleName: ''}
      self.appMenuIdList = []
      self.modifyDialog = false
    },

    // 打开 管理者权限信息弹窗
    openDetailDialog: function (item) {
      let self = this

      let str = {
        appRoleId: item.appRoleId,
      }

      self.detailForm = {
        appRoleName: '',
        menuList: [],
      }
      self.detailDialog = true
      self.dataListLoading = true

      self.$axios
        ._getAppRoleDetail(str)
        .then((res) => {
          self.dataListLoading = false
          const datas = res.data

          if (datas.code == 0) {
            self.detailForm = datas.data
            // self.detailForm.menuList = self.detailForm.menuList.filter((data) => {
            //   return data.checked
            // })
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.dataListLoading = false
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员')
        })


    },

    // 关闭 管理者权限信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除管理者权限
    handleDelete(row) {
      let self = this

      self
        .$confirm(`是否确认要删除 "${row.appRoleName}" 管理者权限`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delAppRole(row.appRoleId)
        })
        .then((data) => {
        })
    },

    delAppRole(code) {
      let self = this

      self.$axios
        ._removeAppRole({appRoleId: code})
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/AppRoleList.vue